import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { AlertTriangle, RotateCcw } from "lucide-react";

/**
 * Fallback for the public/home route. Keeps the header + nav mounted and shows a plain
 * "something went wrong" panel so a single crashing section can never blank the whole site.
 */
export default function MarketingErrorFallback() {
  return (
    <div className="min-h-screen text-foreground" data-testid="home-error-fallback">
      <Navbar />
      <div className="max-w-[720px] mx-auto px-5 py-24 text-center">
        <AlertTriangle className="w-10 h-10 text-blaze mx-auto" strokeWidth={1.6} />
        <h1 className="mt-5 font-heading text-3xl font-bold uppercase tracking-tight">Something went wrong</h1>
        <p className="mt-3 text-sm font-body text-secondary-foreground">
          We hit an unexpected error loading this page. The rest of OpticSwap is fine — please try again.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button
            onClick={() => window.location.reload()}
            data-testid="home-error-reload"
            className="inline-flex items-center gap-2 bg-olive hover:bg-olive-bright text-white font-heading font-bold uppercase text-sm px-6 py-3 transition-colors"
          >
            <RotateCcw className="w-4 h-4" /> Reload
          </button>
          <Link
            to="/feed"
            data-testid="home-error-feed"
            className="inline-flex items-center gap-2 border border-sniper hover:border-olive text-secondary-foreground hover:text-foreground font-mono uppercase text-xs px-5 py-3 transition-colors"
          >
            Browse marketplace
          </Link>
        </div>
      </div>
    </div>
  );
}
